module.exports = __webpack_public_path__ + "fb6857038563cd3831e4fd321533139f.jpg";